import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Um painel de gestão mostra número, e número velho é pior que número
      // ausente: 30 segundos é curto o bastante para a tela acompanhar uma
      // correção feita agora, e longo o bastante para trocar de aba não custar
      // uma consulta nova.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

/** Chaves de consulta, num lugar só, para a invalidação não errar o alvo. */
export const queryKeys = {
  sellers: () => ["sellers"] as const,
  seller: (id: string) => ["sellers", id] as const,
  sellerProducts: (id: string) => ["sellers", id, "products"] as const,
  sellerRatings: (id: string) => ["sellers", id, "ratings"] as const,
  sellerBilling: (id: string) => ["sellers", id, "billing"] as const,
  sellerBillingStatus: (id: string) => ["sellers", id, "billingStatus"] as const,
  sellerOrders: (id: string) => ["sellers", id, "orders"] as const,
  users: () => ["users"] as const,
  user: (id: string) => ["users", id] as const,
  userOrders: (id: string) => ["users", id, "orders"] as const,
  userAddresses: (id: string) => ["users", id, "addresses"] as const,
  userCoupons: (id: string) => ["users", id, "coupons"] as const,
  userSubscriptions: (id: string) => ["users", id, "subscriptions"] as const,
  categories: () => ["categories"] as const,
  coupons: () => ["coupons"] as const,
  orders: (range?: string) => ["orders", range ?? "all"] as const,
  configApp: () => ["config", "app"] as const,
  configBilling: () => ["config", "billing"] as const,
  dashboard: (range: string) => ["dashboard", range] as const,
  billingMonth: (year: number, month: number) =>
    ["billing", "month", year, month] as const,
  billingOverdue: () => ["billing", "overdue"] as const,
  billingStatuses: () => ["billing", "statuses"] as const,
  ordersFeed: (range: string, status: string, sellerId: string) =>
    ["orders", "feed", range, status, sellerId] as const,
  notifications: () => ["notifications"] as const,
  geoResolver: () => ["geo", "resolver"] as const,
  aiSettings: () => ["ai", "settings"] as const,
  // A chave entra na chave de consulta só pelo tamanho e pelos 6 últimos
  // caracteres: o cache não guarda a chave inteira.
  aiModels: (provider: string, credential: string) => ["ai", "models", provider, credential] as const,
};
